import { StudentSmartSavers } from './student.model';

class StudentStatsModel {
  percentCorrect: number = undefined;
  secondsPerQuestion: number = undefined;
  smartSaverEarned: StudentSmartSavers;
}

class StudentStatsLifetime {
  studentStats: StudentStatsModel;
  persistenceRoundsComplete: number = undefined;
  lessonsRepeated: number = undefined;

}

class StudentLifetimeStatsModel {
  persistenceRounds: number = undefined;
  exercisesRepeated: number = undefined;
  problemsAttempted: number = undefined;
  problemsCorrect: number = undefined;
  problemTimeTotal: number = undefined;
}

class StudentLastExerciseStatsModel {
  problemsAttempted: number = undefined;
  problemsCorrect: number = undefined;
  problemTimeTotal: number = undefined;
}

class StudentDashboardStatsModel {
  courseProgress: number = undefined;
  lifetimeStats: StudentLifetimeStatsModel;
  lastExerciseStats: StudentLastExerciseStatsModel;
}

class StudentExercisePerformanceModel {
  firstScore: number;
  firstScoreAttempted: number;
  lastScore: number;
  lastScoreAttempted: number;
  bestScore: number;
  bestScoreAttempted: number;
  attempts: number;
}

class StudentSubjectStatsModel {
  totalSubjectProblems: number = undefined;
  correctSubjectProblems: number = undefined;
  totalSubjectExercises: number = undefined;
  completedSubjectExercieIds: number[] = [];
  lastExerciseStatsModel: StudentLastExerciseStatsModel;
}

export {
  StudentStatsModel,
  StudentStatsLifetime,
  StudentLifetimeStatsModel,
  StudentLastExerciseStatsModel,
  StudentDashboardStatsModel,
  StudentSubjectStatsModel,
  StudentExercisePerformanceModel
};
